import { render, staticRenderFns } from "./platedrawer.vue?vue&type=template&id=9b7909e4&scoped=true"
import script from "./platedrawer.vue?vue&type=script&lang=js"
export * from "./platedrawer.vue?vue&type=script&lang=js"
import style0 from "./platedrawer.vue?vue&type=style&index=0&id=9b7909e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7909e4",
  null
  
)

export default component.exports